import React from 'react';
import * as S from './styles';
import { IconCheckmark } from '@veneer/core';
import { useTranslationHelper } from 'src/contexts/dependencyManager/utils';
import useShellContext from 'src/hooks/useShellContext/useShellContext';

interface ActionItemsListProps {
  orderNumber: string;
}

const ActionItemsList: React.FC<ActionItemsListProps> = ({ orderNumber }) => {
  const getText = useTranslationHelper();
  const { navigation } = useShellContext();

  const handleOrderNumberClick = (
    e: React.MouseEvent | React.KeyboardEvent
  ) => {
    e.preventDefault();
    navigation?.push('/account-details/orders');
  };

  const handleManagePlan = (e: React.MouseEvent | React.KeyboardEvent) => {
    e.preventDefault();
    navigation?.push('/hp-all-in-print-plan/overview');
  };

  return (
    <S.ActionsList>
      <S.ActionItems>
        <S.ActionItem>
          <S.ActionIcon>
            <IconCheckmark />
          </S.ActionIcon>
          <S.ActionContent>
            <S.ActionTitle>
              {getText('confirmation.orderNumber', 'Order Number:')}
            </S.ActionTitle>
            <S.ActionLink
              onClick={handleOrderNumberClick}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  handleOrderNumberClick(e);
                }
              }}
              tabIndex={0}
              role="link"
              aria-label={getText(
                'confirmation.orderNumberLink',
                'Link opens Orders'
              )}
            >
              {orderNumber}
            </S.ActionLink>
          </S.ActionContent>
        </S.ActionItem>

        <S.ActionItem>
          <S.ActionIcon>
            <IconCheckmark />
          </S.ActionIcon>
          <S.ActionContent>
            <S.ActionTitle>
              {getText('confirmation.managePlan', 'Manage your')}
            </S.ActionTitle>
            <S.ActionLink
              onClick={handleManagePlan}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  handleManagePlan(e);
                }
              }}
              tabIndex={0}
              role="link"
            >
              {getText('confirmation.managePlanLink', 'HP All-In plan')}
            </S.ActionLink>
          </S.ActionContent>
        </S.ActionItem>
      </S.ActionItems>

      <S.EmailNotification>
        {getText(
          'confirmation.emailNotification',
          'A confirmation email and further details will be sent to you.'
        )}
      </S.EmailNotification>
    </S.ActionsList>
  );
};

export default ActionItemsList;
